/**
 * Frames leaving the wall (delete, archive, move) leave the preview and the
 * docked chat that show them as well, so neither stays open on nothing; a
 * removal the server refuses brings them back into the preview.
 */
import { dismissFrameFromFocusPresentation } from "@/lib/focus-frame-dismissal";
import { openFrames } from "@/lib/open-frames";
import { usePresentationStore } from "@/stores/presentation-store";
import { useWorkspaceConversationOverlay } from "@/stores/workspace-conversation-overlay-store";

/**
 * Take the frames out of the preview and close the docked chat showing one;
 * returns those the preview showed.
 */
export function leavePreview(frameIds: readonly string[]): string[] {
  const docked = useWorkspaceConversationOverlay.getState();
  if (docked.overlay && frameIds.includes(docked.overlay.frame.id)) {
    docked.close();
  }
  return frameIds.filter(
    (id) =>
      usePresentationStore.getState().presentation?.frameIds.includes(id) &&
      dismissFrameFromFocusPresentation(id),
  );
}

/**
 * Show frames whose removal failed again (those `leavePreview` took out)
 * when no preview shows now; a preview shown meanwhile is left alone.
 */
export function returnToPreview(frameIds: readonly string[]): void {
  if (frameIds.length === 0 || usePresentationStore.getState().presentation) {
    return;
  }
  openFrames({ frameIds, origin: "card" });
}
